// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles-module--wrapper--307PC","decorations":"styles-module--decorations--36FfM"};